
































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import ProjectCard from "./project-card.vue";
import ProjectCopy from "./project-copy.vue";
import ProjectSetup from "./project-setup.vue";
import CardSimpleButton from "../../components/bio/card-simple-button.vue";
import DeleteProjectModal from "./delete-project-modal.vue";

export default Vue.extend({
  name: "ProjectList",
  components: {
    ProjectCard,
    ProjectCopy,
    ProjectSetup,
    CardSimpleButton,
    DeleteProjectModal,
  },
  props: {
    selectedMemberId: {
      type: Number,
      default: NaN,
      required: true,
    },
    personalProjectFilter: {
      type: String,
      default: "All Projects",
      required: false,
    },
  },
  data() {
    return {
      showProjectCopy: false,
      showProjectSetup: false,
      showDelete: false,
      copyingProject: null,
      edittingProject: {
        id: null,
        name: null,
        color: null,
        completedPercentage: null,
        description: null,
        hashTags: null,
        completed: false,
        grantedPermissions: [],
        members: [],
        teams: [],
      },
      archiveOrDeleteProject: null,
    };
  },
  computed: {
    ...mapState("session", ["user"]),
    personalProjectResults(): any {
      let groups = [];
      let allProjects = this.$store.state.project.myProjects;
      let projects = allProjects || [];
      let hashTagFilter = null;

      if (this.selectedMemberId !== NaN) {
        projects = projects.filter(
          (project) =>
            (project.members && project.members.filter((member) => member.memberId === this.selectedMemberId).length > 0) ||
            (project.teams &&
              project.teams.filter((projectTeam) => projectTeam.teamMembers && projectTeam.teamMembers.filter((member) => member.memberId === this.selectedMemberId).length > 0).length > 0)
        );
      }

      let tags = [];
      if (this.personalProjectFilter && this.personalProjectFilter.startsWith("#")) {
        hashTagFilter = this.personalProjectFilter.replace("#", "");
        projects = projects.filter((project) => project.hashTagList && project.hashTagList.filter((tag) => tag.text === hashTagFilter).length > 0);

        tags = [hashTagFilter];
      } else {
        if (this.personalProjectFilter === "Completed Projects") {
          projects = projects.filter((project) => project.completed === true);
        } else if (this.personalProjectFilter === "Active Projects") {
          projects = projects.filter((project) => project.completed === false);
        }

        tags = this.getHashTags(projects);
      }

      let noHashTagProjects = projects.filter((project) => !project.hashTagList || project.hashTagList.length < 1);

      if (noHashTagProjects.length > 0) {
        groups.push({
          title: "No # Tags",
          projects: noHashTagProjects,
        });
      }

      tags = tags.sort();

      tags.forEach((hashTag) => {
        let tagedProjects = projects.filter((project) => project.hashTagList && project.hashTagList.filter((tag) => tag.text === hashTag).length > 0);

        if (tagedProjects.length > 0) {
          groups.push({
            title: hashTag,
            projects: projects.filter((project) => project.hashTagList && project.hashTagList.filter((tag) => tag.text === hashTag).length > 0),
          });
        }
      });

      if (groups.length == 0) {
        groups.push({
          title: "No # Tags",
          projects: [],
        });
      }

      return groups;
    },
    hashTags() {
      let hashTags = [];
      let allProjects = this.$store.state.project.myProjects || [];
      allProjects.forEach((project) => {
        hashTags = hashTags.concat(project.hashTagList.map((tag) => tag.text));
      });
      return [...new Set(hashTags)];
    },
  },
  methods: {
    getHashTags(projects) {
      let hashTags = [];
      projects.forEach((project) => {
        hashTags = hashTags.concat(project.hashTagList.map((tag) => tag.text));
      });
      return [...new Set(hashTags)];
    },
    encodeName(hashTag, name) {
      return `${hashTag}--${name}`;
    },
    showProjectCreator() {
      let user = (this as any).user;
      this.edittingProject = {
        id: null,
        name: null,
        color: null,
        completedPercentage: null,
        description: null,
        hashTags: "",
        completed: false,
        grantedPermissions: ["Bio.AssignAuthorRole", "Bio.AssignFan"],
        members: [{ memberId: user.id, memberName: user.nameName, memberEmailAddress: user.memberEmailAddress, memberAvatarImageUrl: user.memberAvatarImageUrl, role: 6, accepted: true }],
        teams: [],
      };
      this.showProjectSetup = true;
    },
    handleCancelProjectCopy() {
      this.showProjectCopy = false;
    },
    handleCancelNewProject() {
      this.showProjectSetup = false;
    },
    showDeleteDialog(project) {
      this.archiveOrDeleteProject = project;
      this.showDelete = true;
    },
    handleDelete() {
      this.$store.dispatch("project/delete", { data: this.archiveOrDeleteProject }).then(() => {
        this.showDelete = false;
      });
    },
    markComplete(project, completed) {
      project.completed = completed;
      this.$store.dispatch("project/update", { data: project }).then(() => {});
    },
    handleOpenProjectEditor(project) {
      this.edittingProject = {
        id: project.id,
        name: project.name,
        color: project.color,
        completedPercentage: project.completedPercentage,
        description: project.description,
        hashTags: project.hashTags,
        completed: project.completed,
        grantedPermissions: project.grantedPermissions,
        members: project.members,
        teams: project.teams,
      };

      this.showProjectSetup = true;
    },
    handleProjectCopy(project) {
      this.copyingProject = {
        id: project.id,
        name: project.name,
        description: project.description,
        hashTags: project.hashTags,
      };

      this.showProjectCopy = true;
    },
    handleRestore(project) {
      this.$store.dispatch("project/unarchive", { data: project }).then((response) => {});
    },
  },
});
